<template>
    <van-popup class="popWrap" v-model="show" @close="close" position="bottom" round :lazy-render="false" closeable :get-container="getContainer" :style="{height: '95%'}">
        <div class="tsa-chooseOnlineFilesDialog"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0)"
        >
            <div class="content">
                <!-- <div class="close">
                    <img src="../../../../assets/images/close3.png" @click="close" alt="">
                </div> -->
                <div class="header">请选择已经可信时间戳认证的文件</div>
                <div class="condition">
                    <!-- <div class="top">
                        <div class="value">
                            <div class="item">
                                <el-checkbox-group v-model="condition.sourceTypes" @change="sourceTypeChange">
                                    <el-checkbox v-for="item in sourceTypeList" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div> -->
                    <div class="top">
                        <div class="value">
                            <div class="item">
                                <TsaConditionSearchV21
                                    v-model="condition.name"
                                    placeholder="请输入文件名称或备注"
                                >
                                </TsaConditionSearchV21>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="value">
                            <div class="item-container">
                                <div class="item">
                                    <TsaConditionSelectV2 v-model="selectSourceType" placeholder="所属平台" :clearable="false" :options="sourceTypeList" />
                                </div>
                                <div class="item">
                                    <TsaConditionSelectV2 v-model="condition.dataBusinessType" placeholder="证据类型" :options="dataBusinessTypeList" />
                                </div>
                                <div class="item">
                                    <TsaConditionSelectV2 v-model="condition.sourceFileUploadType" placeholder="是否存原件" :options="sourceFileUploadTypeList" />
                                </div>
                            </div>
                            <div class="btn-group">
                                <!-- <div class="btn">
                                    <TsaButton plain @click="reset" size="smaller">重置</TsaButton>
                                </div> -->
                                <div class="btn">
                                    <TsaButton @click="serarch" size="smaller" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">搜索</TsaButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-area">
                    <div class="table-container">
                        <TsaTable
                            ref="TsaTable"
                            :data="tableData"
                            customRowKey="id"
                            stripe
                            height="100%" 
                            style="width: 100%"
                            @selection-change="selectionChange"
                            @row-click="rowClick"
                        >
                            <el-table-column
                                type="selection"
                                width="40"
                                :reserve-selection="true"
                                :selectable="checkSelectable"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="文件名称"
                                align="left"
                                min-width="200"
                            >
                                <template slot-scope="scope">
                                    <div class="cell-container" @click.stop="gotoDetail(scope.row)">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                                prop="storeType"
                                label="认证方式"
                                min-width="90"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    {{scope.row.storeType==0? '脱敏认证':'存证'}}
                                </template>
                            </el-table-column> -->
                            <el-table-column
                                prop="dataBusinessType"
                                label="文件类型"
                                width="130"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <div class="cell-container">
                                        {{ scope.row.dataBusinessType | dataBusinessTypeFilter }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="operatedAt"
                                label="认证时间"
                                min-width="150"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <div class="cell-container">
                                        {{scope.row.tsaAt | timeFormat('YYYY-MM-DD HH:mm:ss')}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                width="100"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <div class="table-action-container">
                                        <p class="table-actiob-btn" @click.stop="gotoDetail(scope.row)">详情</p>
                                    </div>
                                </template>
                            </el-table-column>
                        </TsaTable>
                    </div>
                    <div class="tsa-pager-area">
                        <!-- <p class="selection" v-show="multipleSelection.length > 0">已选中<span> {{ multipleSelection.length }} </span>条</p> -->
                        <TsaPager2 v-if="tableData.length > 0" @current-change="currentChange" @size-change="handleSizeChange"
                            :total="total" :current-page.sync="condition.page" :page-size="condition.size"
                            :page-sizes="pageSizes" />
                    </div>
                </div>
            </div>
            <div class="btn-groups">
                <div class="btn">
                    <TsaButton plain size="mediumer" @click="cancel">取消</TsaButton>
                </div>
                <div class="btn">
                    <TsaButton size="mediumer" @click="confirm" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">确认添加</TsaButton>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import tableConfig from '@/config/copyright/tableConfig'
import { categorysList } from '@/config/copyright/categorysList'
import { allFileSearchApi } from "@/api/pan/index";
import commonMixins from '@/mixins/common'
import actionsMinix from '@/mixins/actions'
import { storeTypeList, fileTypeList } from '@/config/values'
import {sourceTypeList} from '@/config/copyright/sourceType'
import { sourceFileUploadTypeList } from '@/config/copyright/sourceFileUploadType'
import { dataBusinessTypeList } from '@/config/copyright/dataBusinessType'
export default {
    data () {
        return {
            show: false,
            loading: false,
            condition: {
                page: 1,
                size: tableConfig['pageSize'],
                sourceTypes: [],
                // 请输入文件名称或备注
                name: '',
                // 证据类型
                dataBusinessType: null,
                sourceFileUploadType:null,
            },
            selectSourceType:null,
            sourceTypeList:[{
                label: '全部平台',
                value: 0
            }, ...sourceTypeList],

            sourceFileUploadTypeList,
            dataBusinessTypeList:JSON.parse(JSON.stringify(dataBusinessTypeList)),
            total: 0,
            
            pageSizes: tableConfig['pageSizes'],
            tableData: [],
            categorysList,
            // 认证方式
            storeTypeList: storeTypeList(this),
            // 文件类型
            fileTypeList: fileTypeList(this),
            multipleSelection: [],
            alreadyCount:null,
            maxPdfSize: 30 * 1024 * 1024,
            ids: []
        }
    },
    mixins: [ commonMixins, actionsMinix ],
    watch: {
        show (val) {
            if (!val) {
                this.loading = false
                this.multipleSelection = []
                this.$refs.TsaTable.clearSelection()
                this.condition = {
                    page: 1,
                    size: tableConfig['pageSize'],
                    // 请输入文件名称或备注
                    name: '',
                    // 证据类型
                    dataBusinessType: null,
                    sourceTypes: [],
                }
                this.tableData = []
                sourceTypeList.map(item => {
                    this.condition.sourceTypes.push(item.value)
                })
                this.sourceTypeList=[{
                    label: '全部平台',
                    value: 0
                }, ...sourceTypeList]
                this.selectSourceType=0;
            }
        },
        selectSourceType(val){
            if(val==0){
                sourceTypeList.map(item => {
                    this.condition.sourceTypes.push(item.value)
                })
            }else{
                this.condition.sourceTypes=[val]
            }
            this.sourceTypeChange(val)
        }
    },
    created(){
        sourceTypeList.map(item => {
            this.condition.sourceTypes.push(item.value)
        })
        this.sourceTypeList=[{
            label: '全部平台',
            value: 0
        }, ...sourceTypeList]
    },
    mounted () {
        // document.body.addEventListener('touchstart', function() {}, true);
        // // 处理滚动（相当于mouseleave）
        // this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.addEventListener('scroll',this.scrollBlur, false);
    },
    beforeDestroy() {
        //this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.removeEventListener('scroll',this.scrollBlur);
    },
    methods: {
        // scrollBlur(){
        //     if (document.activeElement) {
        //         document.activeElement.blur();
        //     }
        // },
        getContainer() {
            return document.querySelector('.main');
        },
        open ({ alreadyCount,ids,onCancel, onConfirm } = {}) {
            this.alreadyCount=alreadyCount;
            this.ids = ids;
            this.selectSourceType=0;
            this.show = true
            this.onCancel = onCancel
            this.onConfirm = onConfirm
            if (this.accountList.length === 0) {
                this.loading = true
                this.getAccountList().then(() => {
                    this.init()
                })
            } else {
                this.init()
            }
        },
        close () {
            this.show = false
        },
        hashSuccessChange () {
            this.condition.page = 1
            this.multipleSelection = []
            this.$refs.TsaTable.clearSelection()
            this.init()
        },
        init () {
            this.loading = true
            let condition = JSON.parse(JSON.stringify(this.condition))
            // condition.startAt = condition.time[0]
            // condition.endAt = condition.time[1]
            // condition.time = null 
            allFileSearchApi(condition).then(({ data, total }) => {
                this.loading = false
                this.tableData = data
                this.total = total
            }).catch(() => {
                this.loading = false
            })
        },
        reset () {
            this.multipleSelection = []
            this.$refs.TsaTable.clearSelection()
            this.condition = {
                page: 1,
                size: tableConfig['pageSize'],
                // 请输入文件名称或备注
                nameOrRemark: '',
                // 签发时间
                time: [],  // startAt endAt
                // 文件类型
                fileType: null,
                // 认证方式
                storeType: null,
                // 申请人账号
                applyAccount: null,
                // 文件hash
                fileHash: null,
            }
            this.init()
        },
        serarch () {
            this.multipleSelection = []
            this.$refs.TsaTable.clearSelection()
            this.condition.page = 1
            this.init()
        },
        sourceTypeChangeCommon (val) {
            let array = dataBusinessTypeList.filter((item) => {
                return [val].indexOf(item.sourceType) > -1
            })
            this.condition.dataBusinessType = null
            this.dataBusinessTypeList = array.length > 0 ? array : JSON.parse(JSON.stringify(dataBusinessTypeList))
            this.condition.page = 1
            this.init()
        },
        sourceTypeChange (val) {
            this.$refs.TsaTable.clearSelection()
            this.multipleSelection = []
            this.sourceTypeChangeCommon(val)
        },
        currentChange (val) {
            this.condition.page = val
            this.init()
        },
        handleSizeChange (val) {
            this.condition.page = 1
            this.condition.size = val
            this.init()
        },
        hide () {
            this.show = false
        },
        cancel () {
            this.show = false
            this.onCancel && this.onCancel()
        },
        confirm () {
            if (this.multipleSelection.length === 0) {
                this.$TsaToastV2.show({
                    message: '请先选择证据'
                })
                return
            }
            if (this.multipleSelection.length > 500) {
                this.$TsaToastV2.show({
                    message: '最多支持选择500条数据'
                })
                return
            }
            if ((this.multipleSelection.length + this.alreadyCount) > 1000) {
                return this.$TsaToastV2.show({
                    type: 'warn',
                    message: '最多支持添加1000个文件'
                })
            }
            let multipleSelection = []
            this.multipleSelection.forEach(item => {
                multipleSelection.push(item)
            })
            this.onConfirm && this.onConfirm(multipleSelection)
        },
        async gotoDetail (row) {
            this.gotoDetailCommon({ row }, 'chooseOnlineFilesDialog')
        },
        // table表格是否勾选
        checkSelectable (row, index) {
            return this.ids.indexOf(row.id) > -1 ||  row.oweStatus === 1 || row.approveStatus === 4 || row.pdfSize > this.maxPdfSize ? false : true
        },
        rowClick ({ row }) {
            if (!this.checkSelectable(row)) {
                return
            }
            if (this.multipleSelection && this.multipleSelection.length === 1) {
                this.$refs.TsaTable.clearSelection()
            }
            this.$refs.TsaTable.toggleRowSelection(row)
        },
        // 表格复选框
        selectionChange (e) {
            // 不参与属性监听的不要放在data中
            this.multipleSelection = e
        },
    }
}
</script>

<style lang="less" scoped>
    .popWrap{
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .tsa-chooseOnlineFilesDialog {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .content {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding:37px 12px 0;
            overflow: auto;
            .header {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-bottom: 22px;
            }
            .condition {
                .top {
                    display: flex;
                    align-items: center;
                    .name {
                        flex-shrink: 0;
                        margin-right: 16px;
                        padding-left: 11px;
                        position: relative;
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        margin-bottom: 12px;
                        &::after {
                            position: absolute;
                            content: '';
                            width: 3px;
                            height: 20px;
                            background: #2368F1;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .value {
                        flex: 1;
                        display: flex;
                        /deep/.item {
                            flex: 1;
                            margin-right: 8px;
                            margin-bottom: 16px;
                            .el-input__inner{
                                height: 32px;
                                line-height:32px;
                                font-size: 12px;
                            }
                            .tsa-conditionSearchV2{
                                display: flex;
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
                .bottom {
                    width: 100%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    .name {
                        flex-shrink: 0;
                        margin-right: 16px;
                        padding-left: 11px;
                        position: relative;
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        margin-bottom: 12px;
                        &::after {
                            position: absolute;
                            content: '';
                            width: 3px;
                            height: 20px;
                            background: #2368F1;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .value {
                        flex: 1;
                        display: flex;
                        justify-content: space-between;
                        .item-container{
                            display: flex;
                            /deep/.item {
                                margin-right: 5px;
                                margin-bottom: 16px;
                                .el-input__inner{
                                    height: 32px;
                                    line-height:32px;
                                    font-size: 12px;
                                }
                                .el-input__icon{
                                    line-height: 32px;
                                }
                                .tsa-conditionSelectV2-container{
                                    display: flex;
                                }
                            }
                        }
                        .btn-group {
                            display: flex;
                            .btn {
                                width: 62px;
                                margin-left: 8px;
                                .tsa-button{
                                    box-sizing: border-box;
                                }
                            }
                        }
                    }
                }
            }
            .bottom-area {
                flex: 1;
                box-sizing: border-box;
                overflow: hidden;
                padding-bottom: 20px;
                display: flex;
                flex-direction: column;
                /deep/.table-container {
                    flex: 1;
                    overflow: auto;
                    margin-bottom: 20px;
                    .tsa-customTable2 {
                        .el-table__body-wrapper {
                            .el-table__row {
                                cursor: pointer;
                            }
                        }
                    }
                    .cell{
                        padding: 0 !important;
                        .cell-container{
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            word-break: break-all;
                            white-space: nowrap;
                        }
                        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
                            background-color:#0047FF;
                            background-color:#0047FF;
                        }
                    }
                }
                .tsa-pager-area {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    flex-shrink: 0;
                    .selection {
                        flex: 1;
                        font-size: 14px;
                        span {
                            color: #2368F1;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        .btn-groups {
            height: 76px;
            box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
            display: flex;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            .btn {
                width: 166px;
                height: 44px;
                margin: 0 10px;
            }
        }
    }
</style>